import { render, staticRenderFns } from "./VisitsTab.vue?vue&type=template&id=32ec89b8"
import script from "./VisitsTab.vue?vue&type=script&lang=js"
export * from "./VisitsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports